import * as React from 'react'
import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'

type Props = {
  backgroundImage: string
  className?: string
  sticky?: boolean
  children: React.ReactNode
}
export const CompanyAndInvestorSummaryBg: React.FC<Props> = (props) => {
  return (
    <div
      className={props.className}
      css={css`
        width: 100%;
        max-width: ${props.sticky ? '100%' : '1280px'};
        margin-inline: auto;
        ${mq.large} {
          position: sticky;
          z-index: 20;
          top: -200px;
          transition: max-width 0.16s 0s linear;
        }
      `}
    >
      <div
        css={css`
          min-height: 196px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          position: relative;
          background-blend-mode: multiply;
          background:
            url(${props.backgroundImage}) 50% 0 no-repeat,
            linear-gradient(
                to bottom,
                ${colors.blueGray50} 0,
                transparent 196px
              )
              no-repeat;
          background-size: auto 196px;
          border-radius: 0;
          ${mq.large} {
            min-height: 360px;
            background:
              url(${props.backgroundImage}) 50% 50% no-repeat,
              linear-gradient(
                to bottom,
                ${colors.blueGray50} 100%,
                transparent 0
              );
            background-size: cover;
            border-radius: ${props.sticky ? '0' : '8px'};
          }
        `}
      >
        {props.children}
      </div>
    </div>
  )
}
